export default "__VITE_ASSET__B_r_STo9__"